// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/cruising-altitude.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/cruising-altitude/cruising-altitude.js';

mount([g0]);
